import { render, staticRenderFns } from "./GiftedPatron.vue?vue&type=template&id=66739eb9&scoped=true&"
import script from "./GiftedPatron.vue?vue&type=script&lang=js&"
export * from "./GiftedPatron.vue?vue&type=script&lang=js&"
import style0 from "./GiftedPatron.vue?vue&type=style&index=0&id=66739eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66739eb9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatronAvatar: require('/home/bitrix/frontend/components/forms/PatronAvatar.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
